export const isAuthenticated = () => {
    const token = localStorage.getItem('jwt');
    return token != null; // Returns true if the token exists
};

// Decode JWT token to get user roles
export const getUserRoles = () => {
    const token = localStorage.getItem('jwt');
    if (!token) return [];

    try {
        // JWT structure: header.payload.signature
        const payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payload));
        return decodedPayload.roles || [];
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return [];
    }
};

// Check if user has admin role
export const isAdmin = () => {
    const roles = getUserRoles();
    return roles.includes('ADMIN');
};

// Check if user has case reviewer role
export const isCaseReviewer = () => {
    const roles = getUserRoles();
    return roles.includes('CASE_REVIEWER');
};

// Check if user has any of the specified roles
export const hasAnyRole = (...rolesToCheck) => {
    const userRoles = getUserRoles();
    return rolesToCheck.some(role => userRoles.includes(role));
};

// Get user's display name from JWT token
export const getUserName = () => {
    const token = localStorage.getItem('jwt');
    if (!token) return null;

    try {
        // JWT structure: header.payload.signature
        const payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payload));

        const firstName = decodedPayload.name || '';
        const lastName = decodedPayload.lastName || '';

        // Combine first and last name, handling nulls
        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        } else if (firstName) {
            return firstName;
        } else if (lastName) {
            return lastName;
        }

        return null;
    } catch (error) {
        console.error('Error decoding JWT for user name:', error);
        return null;
    }
};

// Get user's email from JWT token
export const getUserEmail = () => {
    const token = localStorage.getItem('jwt');
    if (!token) return null;

    try {
        // JWT structure: header.payload.signature
        const payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payload));
        return decodedPayload.sub || decodedPayload.email || null;
    } catch (error) {
        console.error('Error decoding JWT for user email:', error);
        return null;
    }
};